module.exports = __webpack_public_path__ + "static/media/gbbg.f48aa71f.jpg";